import { UserForm } from "./UserForm";
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
} from "react-admin";

export const UserCreate = () => {
  return (
    <Create redirect={false}>
      <SimpleForm mode="onBlur" reValidateMode="onBlur">
        <TextInput source="email" isRequired validate={required()} />
        <UserForm />
        <ReferenceInput source="role.id" reference="roles">
          <SelectInput
            optionText="name"
            source="role"
            isRequired
            validate={required()}
          />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};
